import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import Pagination from "../../components/Panigation";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, CircularProgress, Alert } from "@mui/material";
import { useGetNotificationsQuery, useBulkMarkAsReadMutation } from "../../service/notifications/api";
import { toast } from "react-toastify";
import { Button as MuiButton } from "@mui/material";



const RecievedNotifications = () => {

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const limit = 15;
    const [bulkMarkAsRead, { isLoading: bulkMarkLoading }] = useBulkMarkAsReadMutation();


    // Reset to page 1 when search term changes
    useEffect(() => {
        setPage(1);
    }, [searchTerm]);

    const { data: notificationsData, isLoading, error } = useGetNotificationsQuery({
        page,
        limit,
        search: searchTerm,
    });

    const unreadCount = notificationsData?.data?.unreadCount || 0;

    const handleMarkAllAsRead = async () => {
        try {
            await bulkMarkAsRead({}).unwrap();
            toast.success("All notifications marked as read");
        } catch (err) {
            console.error("Failed to mark all as read:", err);
            toast.error("Failed to mark all as read");
        }
    };


    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const notifications = notificationsData?.data?.data || [];
    const paginator = notificationsData?.data?.paginator;
    const slNo = paginator?.slNo || 1;

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const handleNotificationClick = (notification: any) => {
        const title = notification.title?.toLowerCase() || "";
        if (title.includes("user")) {
            navigate("/manage-users");
        } else if (title.includes("car") || title.includes("vehicle") || title.includes("listed")) {
            navigate("/manage-vehicles");
        }
    };

    return (
        <>
            <CommonBreadcrumb
                title="Received Notifications"
                breadcrumbItems={[
                    { label: "Dashboard", onClick: () => navigate("/dashboard") },
                    { label: "Received Notifications" },
                ]}
            />

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search notifications..."
                        />
                    </div>
                    <div className="right_s">
                        <MuiButton
                            className="btn btn_primary sm"
                            onClick={handleMarkAllAsRead}
                            disabled={unreadCount === 0 || bulkMarkLoading}
                            sx={{ 
                                minWidth: '150px',
                                "&.Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    color: "#999",
                                    opacity: 0.7,
                                    cursor: 'not-allowed',
                                    pointerEvents: 'auto'
                                }
                            }}
                        >
                            {bulkMarkLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : "Mark All as Read"}
                        </MuiButton>

                    </div>
                </div>

                
                {isLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </Box>
                )}

                {error && (
                    <Box sx={{ padding: '16px' }}>
                        <Alert severity="error">Failed to load notifications</Alert>
                    </Box>
                )}

                {!isLoading && !error && notifications.length === 0 && (
                    <Box sx={{ padding: '32px', textAlign: 'center' }}>
                        <p>No notifications found</p>
                    </Box>
                )}

                {!isLoading && !error && notifications.length > 0 && (
                    <>
                        <TableContainer className="table_container">
                            <Box className="heading"></Box>
                            <Table sx={{ minWidth: 650 }} aria-label="notifications table" className="v3">
                                <TableHead>
                                    <TableRow hover>
                                        <TableCell width="60px">Sr.No</TableCell>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Message</TableCell>
                                        <TableCell width="180px">Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {notifications.map((notification, index) => (
                                        <TableRow 
                                            key={notification._id} 
                                            hover 
                                            sx={{ backgroundColor: !notification.isRead ? '#e8f0fe !important' : 'transparent', cursor: 'pointer' }}
                                            onClick={() => handleNotificationClick(notification)}
                                        >
                                            <TableCell>{slNo + index}</TableCell>
                                            <TableCell sx={{ fontWeight: !notification.isRead ? 600 : 400 }}>
                                                {notification.title}
                                            </TableCell>
                                            <TableCell className="max_c2">
                                                <p>{notification.message}</p>
                                            </TableCell>
                                            <TableCell>{formatDate(notification.createdAt)}</TableCell>
                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>
                        </TableContainer>

                        {paginator && paginator.itemCount > 15 && (
                            <Pagination
                                module={notifications}
                                page={page}
                                setPage={setPage}
                                onPageChange={(newPage: number) => setPage(newPage)}
                                totalPages={paginator.pageCount || 1}
                                totalCount={paginator.itemCount || 0}
                            />
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default RecievedNotifications;
